var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon fill-current",attrs:{"width":"10","height":"7","viewBox":"0 0 10 7","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M4.7 6.1L-3.72843e-07 1.4L1.4 3.72843e-07L4.7 3.3L8 2.13053e-06L9.4 1.4L4.7 6.1Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }